import { render } from "./LoginHeader.vue?vue&type=template&id=55c7b5a6"
import script from "./LoginHeader.vue?vue&type=script&lang=js"
export * from "./LoginHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__